import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import Swal from "sweetalert2";
import WithdrawalsForms from "./withdrawals-forms";
import './withdrawals.css';

function Withdrawals() {
    const [masterValue, setMasterValue] = useState(''); // Estado para guardar el valor de la master introducido en el input
    const [view, setView] = useState('input');  // Estado para manejar que vista ver
    const [error, setError] = useState(''); // Estado para manejar errores
    const [masterData, setMasterData] = useState(null);  // Estado para guardar los datos de una guia master si es que se encuentra
    const [buttonNotice, setButtonNotice] = useState(false);
    const [generatedNotice, setGeneratedNotice] = useState(false);
    const [generatedDate, setGeneratedDate] = useState(null);
    const [subproductsState, setSubproductsState] = useState([]);  // Estado para cuando la master tenga houses

    const mockData = [
        {
          number: '111-12345678',
          type: 'directa',
          merchandiseType: 'Cont activos',
          pzas: 2,
          weight: 27.00,
          cliente: 'FedEx',
          fecha: '2025-04-10',
          origen: 'CMX',
          destino: 'GDL',
          subproducts: [],
        },
        {
          number: '222-87654321',
          type: 'parcial',
          merchandiseType: 'Carga general',
          pzas: 4,
          weight: 48.30,
          cliente: 'UPS',
          fecha: '2025-04-11',
          origen: 'MTY',
          destino: 'TIJ',
          subproducts: [
            { hbs: 'HBS-001', fecha: '2025-04-10', piezas: 1, peso: 5, volume: 17.89 },
            { hbs: 'HBS-002', fecha: '2025-04-11', piezas: 3, peso: 4, volume: 22.43 },
          ]
        }
    ];

    const handleInputChange = (e) => {
        let value = e.target.value; // Permitimos letras y números

        if (value.length > 3 && value[3] !== "-") {
            value = value.slice(0, 3) + "-" + value.slice(3);
        }

        setMasterValue(value);
        if (error) setError(''); // Borra el error cuando el usuario escribe
    };
    

    const handleSearch = () => {
        if (!masterValue.trim()) {  // Verifica si el input está vacío
            setError("Este campo es obligatorio");
            return;
        }

        const guide = mockData.find((item) => item.number === masterValue);
        if (guide) {
            setMasterData(guide); // guardamos todo el objeto
            //setButtonNotice(true);
            if (guide.subproducts && guide.subproducts.length > 0) {
                const initialState = guide.subproducts.map(sub => ({
                    ...sub,
                    noticeGenerated: false,
                    generatedDate: null,
                }));
                setSubproductsState(initialState);
            } else {
                setButtonNotice(true);
            }
        } else {
            Swal.fire({
                title: "La master no existe.",
                icon: "warning",
                iconColor: '#FCC732',
                customClass: {
                    confirmButton: 'btn-ok',
                    title: 'alert-title',
                    popup: 'alert-bg'
                }
            });
        }
    };

    const handleContinue = () => {
        setView('forms');
    };

    const handleGenerateNotice = () => {
        const now = new Date();
        const formattedDate = now.toLocaleString('sv-SE', {
            timeZone: 'America/Mexico_City',
            hour12: false
        }).replace('T', ' ');
        setGeneratedDate(formattedDate);
        setGeneratedNotice(true);
    }

    const handleGenerateSubNotice = (index) => {
        const now = new Date();
        const formattedDate = now.toLocaleString('sv-SE', {
            timeZone: 'America/Mexico_City',
            hour12: false
        }).replace('T', ' ');

        const updated = [...subproductsState];
        updated[index].noticeGenerated = true;
        updated[index].generatedDate = formattedDate;
        setSubproductsState(updated);
    };

    const handleContinueSubproduct = (subproduct) => {
        setMasterData({
            ...masterData,
            selectedSubproduct: subproduct
        });
        setView('forms');
    };

    // Para limpiar los datos al regresar a esta vista (Cancelar Desistimiento)
    const resetFormState = () => {
        setView('input');
        setMasterValue('');
        setButtonNotice(false);
        setGeneratedNotice(false);
        setGeneratedDate(null);
        setMasterData(null);
    };

    return(
        <>
            <Helmet>
                <title>Horus | Desistimientos</title>
            </Helmet>
            <ScrollToTop />

            <div className="container-fluid">
                {view === 'input' && (
                <div className="row justify-content-center">
                    <div className="col-6">
                        <label for="inputMaster" class="amc-label">Master</label>
                        <input 
                            type="text"
                            class="form-control"
                            id="inputMaster"
                            value={masterValue}
                            onChange={handleInputChange}
                        />
                        {error && <small className="text-danger">{error}</small>}
                        <div className="btns mt-3 d-flex justify-content-end gap-3">
                            <button className='btnn' onClick={handleSearch} >Buscar</button>
                        </div>
                        {generatedNotice && (
                            <div className="row justify-content-end mt-3">
                                <div className="col-3">
                                    <p style={{marginBottom:'0rem'}} className="text-generated-notice">
                                        Aviso generado el: {generatedDate}
                                    </p>
                                </div>
                            </div>
                        )}
                        {buttonNotice && (
                            <div className="btns mt-2 d-flex justify-content-end gap-3">
                                <button 
                                    className='btnn' 
                                    onClick={generatedNotice ? handleContinue : handleGenerateNotice}
                                >
                                    {generatedNotice ? 'Continuar' : 'Generar aviso'}
                                </button>
                            </div>
                        )}

                        {/* Tabla para cuando la guia master tenga houses */}
                        {subproductsState.length > 0 && (
                            <div className="mt-4">
                                <table className="table table-striped mt-3">
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>HBS</th>
                                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Generar aviso</th>
                                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        {subproductsState.map((sub, index) => (
                                            <tr key={sub.hbs}>
                                                <td>{sub.hbs}</td>
                                                <td>
                                                {!sub.noticeGenerated ? (
                                                    <button className='btnn' onClick={() => handleGenerateSubNotice(index)}>Generar aviso</button>
                                                ) : (
                                                    <p className="text-generated-notice" style={{ margin: 0 }}>
                                                        Aviso generado el: {sub.generatedDate}
                                                    </p>
                                                )}
                                                </td>
                                                <td>
                                                {sub.noticeGenerated ? (
                                                    <button className='btnn' onClick={() => handleContinueSubproduct(sub)}>Continuar</button>
                                                ) : (
                                                    <span>-</span>
                                                )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
                )}

                {view === 'forms' && <WithdrawalsForms master={masterData} subproduct={masterData.selectedSubproduct || null} onCancel={resetFormState} />}
            </div>
        </>
    );
}

export default Withdrawals;